import { Steps } from 'antd5';
import styled from 'styled-components';

/**
 * Styles Antd's Steps component with Horizon theme colors and applies
 * colors to the lines between steps in a way that better suits our
 * workflows.
 *
 * Optional `itemWidth` property sets the width of each item's content.
 * Must be a valid css width string.
 */
export const StyledSteps = styled(Steps)<{ itemWidth?: string }>`
  ${({ theme, itemWidth }) => `
    .ant-steps-item {
      ${
        itemWidth &&
        `
        .ant-steps-item-content {
          width: ${itemWidth} !important;
        }
      `
      }

      .ant-steps-item-title {
        color: ${theme.labelColor} !important;
      }
      
      &.ant-steps-item-active {
        .ant-steps-item-tail::after {
          background-color: ${theme.disabledTextColor} !important;
        }
      }

      &.ant-steps-item-wait {
        .ant-steps-item-tail::after,
        .ant-steps-icon-dot {
          background-color: ${theme.disabledTextColor} !important;
          border-color: ${theme.disabledTextColor} !important;
        }
      }

      &:not(.ant-steps-item-active) {
        &.ant-steps-item-finish {
          .ant-steps-item-tail::after,
          .ant-steps-icon-dot {
            background-color: ${theme.green} !important;
            border-color: ${theme.green} !important;
          }
        }
  
        &.ant-steps-item-error {
          .ant-steps-item-tail::after,
          .ant-steps-icon-dot {
            background-color: ${theme.red} !important;
            border-color: ${theme.red} !important;
          }
        }
      }
    }
  `}
`;
